// Get the element you want to add/remove the class from
const myElement = document.getElementById('sticky-add-to-cart-block');

// Define the scroll threshold (in pixels)
const scrollThreshold = 700; // Add class after scrolling 200px

// Add a scroll event listener to the window
window.addEventListener('scroll', () => {
  // Get the current vertical scroll position
  const currentScrollPos = window.scrollY;

  // Check if the scroll position exceeds the threshold
  if (currentScrollPos > scrollThreshold) {
    // Add the class if the scroll position is past the threshold
    myElement.classList.add('show');
  } else {
    // Remove the class if the scroll position is above the threshold
    myElement.classList.remove('show');
  }
});